import ColorField from '../../Inputs/ColorField'
import PropertyTreeNode from '../Node/PropertyTreeNode'

const PropertyTreeColorNode = (props) => {
  return <PropertyTreeNode {...props} input={<ColorField {...props} />} />
}
export default PropertyTreeColorNode
